var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.213 13.196a.986.986 0 0 1 1.393 0l6.598 6.593c.63.629.188 1.711-.697 1.711H6.313c-.886 0-1.326-1.082-.697-1.71l6.597-6.594Zm1.394-2.392a.986.986 0 0 1-1.394 0L5.615 4.21c-.63-.628-.189-1.71.698-1.71h13.193c.886 0 1.326 1.082.697 1.71l-6.596 6.594Zm-1.882.492a1.005 1.005 0 0 1 0 1.408l-6.53 6.66c-.623.636-1.695.191-1.695-.702V5.34c0-.895 1.072-1.34 1.694-.705l6.53 6.662v-.001Z"
  })));
};
export default SvgLogo;